import { instance } from "libs/api";

import { ApiRoutesDeliveries } from "../../constants";
import { DriverDeliveriesReportItem } from "../../financial.types";
import { GetDriversDeliveriesReportRequestParams } from "./getDriversDeliveriesReport.types";

export const requestDriversDeliveriesReport = async (
  params: GetDriversDeliveriesReportRequestParams
): Promise<DriverDeliveriesReportItem[]> => {
  return await instance.get(ApiRoutesDeliveries.DriversDeliveriesReport, {
    params
  });
};
